// extracted by mini-css-extract-plugin
export default {"root":"ForgotPasswordForm_root__PgO+V","form":"ForgotPasswordForm_form__ZfQac","error":"ForgotPasswordForm_error__GbZqj","submit-button":"ForgotPasswordForm_submit-button__38cel"};